PagedCollection = require('base/paged-collection')

class ProfileCollection extends PagedCollection
  url: 'salesforce/profiles'

module.exports = ProfileCollection
